// dark-theme.ts
import { createTheme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import {
    signature,
    neutral,
    support,
    focusRing,
    shadows,
    radius,
    typography,
    signatureBorderStyleButtons,
} from "./theme-tokens";

const dark = createTheme({
    layout: {
        mobile: {
            menu: {
                drawer: {
                    width: '90vw'
                }
            }
        }
    },
    palette: {
        mode: "dark",
        primary: {
            main: signature.main,
            light: signature[400],
            dark: signature[700],
            contrastText: "#000000",
        },
        secondary: {
            main: neutral[200],
            contrastText: "#000000",
        },
        breakout: support.breakout,
        error: support.error,
        warning: support.warning,
        info: support.info,
        success: support.success,
        background: {
            default: neutral[900],
            paper: neutral[800],
            dark: neutral[1000]
        },
        text: {
            primary: signature[50],
            secondary: neutral[400],
            disabled: alpha(neutral[50], 0.38),
        },
        divider: alpha(signature.main, 0.14),
        action: {
            active: neutral[50],
            hover: alpha(neutral[0], 0.08),
            selected: alpha(neutral[0], 0.12),
            disabled: alpha(neutral[0], 0.38),
            disabledBackground: alpha(neutral[0], 0.12),
            focus: alpha(neutral[0], 0.08),
        },
    },
    // @ts-expect-error - ignore
    typography,
    shape: { borderRadius: radius.sm },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: { backgroundColor: neutral[900], color: neutral[100] },
                '*:focus-visible': focusRing(neutral[900]),
                '@media (prefers-reduced-motion: reduce)': {
                    '*': { animationDuration: '0.01ms !important', animationIterationCount: '1 !important', transitionDuration: '0.01ms !important', scrollBehavior: 'auto !important' },
                },
            },
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    '&.Mui-focusVisible': focusRing(neutral[900]),
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: {
                    borderColor: alpha(neutral[0], 0.25)
                }
            }
        },
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    subtitle1: 'p',
                    subtitle2: 'p',
                },
            },
            styleOverrides: {
                // h1: ({ theme }) => ({ color: theme.palette.primary.main }),
                // h2: ({ theme }) => ({ color: theme.palette.primary.main }),
                // h3: ({ theme }) => ({ color: theme.palette.primary.main }),
                // h4: ({ theme }) => ({ color: theme.palette.primary.main }),
                // h5: ({ theme }) => ({ color: theme.palette.primary.main }),
                // h6: ({ theme }) => ({ color: theme.palette.primary.main }),
                // subtitle1: { color: neutral[400] },
                // subtitle2: { color: signature[200] },
                caption: { color: neutral[100] },
            },
        },
        MuiPaper: {
            defaultProps: { elevation: 0 },
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    // backgroundColor: 'background.paper',
                    backdropFilter: 'blur(5px)',
                    borderRadius: '8px'
                },
                outlined: { borderColor: alpha(neutral[0], 0.12) },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: { boxShadow: shadows.level2(neutral[1000]) },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    paddingLeft: '25px',
                    paddingRight: '25px',
                    ...signatureBorderStyleButtons,
                },
                containedPrimary: { color: "#000" },
                containedSecondary: { color: "#000" },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: signature.main,
                    textUnderlineOffset: 3,
                    textDecoration: 'none',
                    borderBottom: `1px dashed ${alpha(signature.main, .5)}`,
                    transition: 'color 0.3s ease, border-bottom-color 0.3s ease',
                    '&:hover': {
                        color: signature[400],
                        borderBottom: `1px solid ${alpha(signature[300], .9)}`,
                    },
                    '&:focus-visible': focusRing(neutral[900]),
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: neutral[50],
                    color: neutral[900],
                    ...(typography.body1)
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: neutral[900],
                    color: neutral[50],
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                }
            }
        },
    },
});

export default dark;
